<template>
    <div
        v-if="ticket.soid && ticket.code !== 0"
        class="view-progress-btn"
        @click="jumpPage(ticket.soid)"
    >
        查看服务进度
    </div>
</template>

<style lang="less" scoped>
.view-progress-btn {
    width: 1.68rem;
    height: 0.48rem;
    margin: 0.4rem auto 0;
    border-radius: 0.24rem;
    font-size: 0.15rem;
    line-height: 0.48rem;
    color: #FE3666;
    border: 0.01rem solid #FE3666;
    text-align: center;
}
</style>

<script>
import { mapState } from 'vuex';
import { jumpViewProgress, jump } from '@/utils/util';
import { sendClickImmediately } from '@/common/weblog';
export default {
    name: 'view-progress',
    props: {
        // 区分端外还是端内链接
        mustLoggedOn: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapState(['ticket', 'myServiceBizKey']),
    },
    methods: {
        // 跳转端外链接 后端生成key，通过key绑定userId、soid等参数，前端将key拼接在页面url上，才会免登录
        jumpProcessOut(soid, key) {
            const host = window.location.host;
            const isProd = host.indexOf('staging.kuaishou.com') === -1;
            const url = isProd ? 'https://csc.m.kuaishou.com' : 'https://csc-center.staging.kuaishou.com';
            const entranceId = isProd ? 1 : 1490;
            jump(`${url}/service/?enableWK=1&layoutType=4&hyId=kuaishou_csc#/service-detail?soid=${soid}&bizKey=${key}&entranceId=${entranceId}`);
        },
        jumpPage() {
            sendClickImmediately('SERVICE_PROGRESS_CLICK');
            setTimeout(() => {
                // 端外并且有myServiceBizKey值 跳转端外链接
                if (!this.mustLoggedOn && this.myServiceBizKey) {
                    this.jumpProcessOut(this.ticket.soid, this.myServiceBizKey);
                    return;
                }
                jumpViewProgress(this.ticket.soid);
            }, 100);
        },
    },
};
</script>
